import { useNavigate, useLocation } from "react-router-dom"
import { useState, useEffect } from "react"

const NavSearchBar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [search, setSearch] = useState("")
  const [focused, setFocused] = useState(false)

  /* =========================
     SYNC WITH URL
  ========================= */
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const q = params.get("search") || ""
    setSearch(q)
  }, [location.search])

  /* =========================
     DEBOUNCE NAVIGATION
  ========================= */
  useEffect(() => {
    const delay = setTimeout(() => {
      const query = search.trim()
      const current = new URLSearchParams(location.search).get("search") || ""

      if (query === current) return

      if (query) {
        navigate(`/products?search=${encodeURIComponent(query)}`, {
          replace: true,
        })
      } else {
        navigate(`/products`, { replace: true })
      }
    }, 400)

    return () => clearTimeout(delay)
  }, [search, navigate, location.search])

  /* =========================
     ENTER KEY SUPPORT
  ========================= */
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const query = search.trim()

      if (query) {
        navigate(`/products?search=${encodeURIComponent(query)}`)
      } else {
        navigate(`/products`)
      }
    }
  }

  return (
    <div className="w-100 d-flex justify-content-center">
      <div
        className={`d-flex align-items-center search-pill ${
          focused ? "search-focused" : ""
        }`}
      >
        {/* INPUT */}
        <input
          type="search"
          className="search-input"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={handleKeyDown}
        />

        {/* BUTTON */}
        <button
          type="button"
          className="search-btn"
          onClick={() => {
            const query = search.trim()
            navigate(
              query
                ? `/products?search=${encodeURIComponent(query)}`
                : "/products",
            )
          }}
        >
          <img
            src="images/searchbaricon.png"
            alt="search"
            className="search-icon"
          />
        </button>
      </div>

      <style>{`
        .search-pill {
          width: 100%;
          max-width: 600px;
          border: 1px solid #dee2e6;
          border-radius: 999px;
          padding: 6px 10px;
          background: #fff;
          transition: all 0.2s ease;
        }

        .search-focused {
          border-color: #3c7e23;
          box-shadow: 0 0 0 4px #3c5e23;
        }

        .search-input {
          flex: 1;
          border: none;
          outline: none;
          padding: 8px 12px;
          font-size: 14px;
          background: transparent;
        }

        .search-btn {
          border: none;
          background: #3c9e23;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.2s;
        }

        .search-btn:hover {
          background: #3c7e23;
        }

        .search-icon {
          width: 16px;
          height: 16px;
          filter: brightness(0) invert(1);
        }
      `}</style>
    </div>
  )
}

export default NavSearchBar
